import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from "highcharts/highcharts-more.js"
import solidGauge from "highcharts/modules/solid-gauge.js";

highchartsMore(Highcharts);
solidGauge(Highcharts);

class ChartGauge extends React.Component  {

  constructor(props) {
    super(props);
  }

  render() {

    let options = {
      chart: {
            type: 'solidgauge'
        },

        title: null,

        pane: {
            startAngle: -90,
            endAngle: 90,
            background: {
                backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
                innerRadius: '60%',
                outerRadius: '100%',
                shape: 'arc'
            }
        },

        exporting: {
            enabled: false
        },

        credits: false,

        tooltip: {
            enabled: false
        },

        yAxis: {
            min: 0,
            max: 100,
            stops: [
                [0.1, '#55BF3B'], // green
                [0.6, '#DDDF0D'], // yellow
                [0.7, '#DF5353'] // red
            ],
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickAmount: 2,
            title: {
                text: this.props.title,
                y: -90,
                style: {
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
            },
            labels: {
                y: 16
            }
        },

        plotOptions: {
            solidgauge: {
                dataLabels: {
                    y: -50,
                    borderWidth: 0,
                    useHTML: true
                }
            }
        },

        series: [{
            name: 'Risk',
            data: [this.props.risk],
            dataLabels: {
                format:
                    '<div style="text-align:center">' +
                      '<span style="font-size:25px">{y}</span> <br/>' +
                      '<span style="font-size:12px;opacity:0.4"> risk (%) </span>' +
                    '</div>'
            }
        }]
    };

    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    )
  }
}

export default ChartGauge;
